import { AxiosResponse } from 'axios';
import _ from 'lodash';
import Vue from 'vue';

import { ErrorResponse, HttpStatusCode } from '@codequality/vue-cli-base';

enum CommandType {
  save = '保存',
  delete = '削除',
}

export default Vue.extend({
  name: 'AlertMixin',

  methods: {
    async isCancelOrValidationErrorResponseToDelete<T>(
      request: () => Promise<AxiosResponse<T | ErrorResponse>>
    ): Promise<boolean> {
      if (!confirm(`${CommandType.delete}しますか？`)) return Promise.resolve(true);
      const response = await request();
      const isError = this.isValidationErrorResponseToDelete(response);
      return Promise.resolve(isError);
    },
    isValidationErrorResponseToSave<T>(response: AxiosResponse<T | ErrorResponse>): boolean {
      return this.$_isValidationErrorResponse(response, CommandType.save);
    },
    isValidationErrorResponseToDelete<T>(response: AxiosResponse<T | ErrorResponse>): boolean {
      return this.$_isValidationErrorResponse(response, CommandType.delete);
    },
    /**
     * response が 正常かエラーかを返却します（エラーの場合はエラーメッセージを編集して表示）
     *
     * @param response
     * @param removeFieldPrefixes
     * メッセージから 特定の prefix を除外するための引数
     * 指定した prefix が errors[n].field に含まれる場合、その prefix をメッセージから除外する
     *   例：
     *     removeFieldPrefixes = ['a.b.c', 'a.b.'] の場合
     *     field = 'a.b.d' なら 'a.b.' を除外し 'd' を残す
     *     field = 'a.b.c' なら removeFieldPrefixes の index が小さい方優先で 'a.b.c' を除外する
     * @returns
     */
    isValidationErrorResponse<T>(
      response: AxiosResponse<T | ErrorResponse>,
      ...removeFieldPrefixes: string[]
    ): boolean {
      if (response.status === 200) return false;

      const errorResponse = response.data as ErrorResponse;
      let messages: string[] = [];

      switch (response.status) {
        case HttpStatusCode.badRequest:
          if (errorResponse === null || errorResponse.errors === undefined) return false;

          // fieldの頭のcを削る関数
          const getFieldName = (f: string) => {
            return f.startsWith('c') ? f.substring(1) : f;
          };

          for (const e of errorResponse.errors) {
            // fieldを持っていない場合はmessagesに追加しない
            if (!_.has(e, 'field')) continue;

            let field = e.field;
            const prefix = removeFieldPrefixes.find((r) => e.field.includes(r));
            if (prefix !== undefined) {
              field = e.field.replace(prefix, '');
            }

            // リストの要素にアノテーションしてチェックした場合はメッセージだけ出力
            if (field.endsWith('<list element>')) {
              messages.push(e.defaultMessage);
              continue;
            }

            let subject = '';
            const fields = field.split('.');
            fields.forEach((value, index) => {
              const regexp = new RegExp('(.+)\\[(\\d+)\\]');
              const match = value.match(regexp);
              if (match === null) {
                // 配列ではない
                subject += getFieldName(value);
              } else {
                // 配列
                subject += `${parseInt(match[2]) + 1}番目の${getFieldName(match[1])}`;
              }
              // 最後の項目でない場合は区切り文字を出力
              if (index !== fields.length - 1) subject += ' : ';
            });
            messages.push(`${subject !== '' ? subject + 'は' : ''}${e.defaultMessage}`);
          }
          messages = _.uniq(messages);
          messages = _.sortBy(messages);
          break;
        case HttpStatusCode.unauthorized:
          messages.push(errorResponse.message);
          break;
        default:
          break;
      }
      alert(messages.join('\n'));
      return true;
    },
    $_isValidationErrorResponse<T>(response: AxiosResponse<T | ErrorResponse>, type: CommandType): boolean {
      if (this.isValidationErrorResponse(response)) return true;
      alert(`${type}しました`);
      return false;
    },
  },
});
